import './index.scss';

import { Component, ReactNode, createRef } from 'react';
import AsideContext from './context';
import { BraxIcon } from 'components/BraxIcon';

export type BraxAsidesProps = {
    children: ReactNode
};

type BraxAsidesState = {
    aside: {
        [id: number]: {
            open: boolean,
            closeable: boolean
        }
    },
    closing: string | false,
    mobile: boolean
};

export class BraxAsides extends Component<BraxAsidesProps, BraxAsidesState> {

    state: BraxAsidesState = {
        aside: {},
        closing: false,
        mobile: window.innerWidth <= 768
    };

    ref = createRef<HTMLDivElement>();

    timeout?: number;

    componentDidMount() {
        window.addEventListener('resize', () => this.checkIsMobile());
    }

    componentDidUpdate(_, nextState: BraxAsidesState) {
        if (this.state.mobile !== nextState.mobile)
            for (const id in nextState.aside)
                if (nextState.aside[id].closeable && !nextState.aside[id].open)
                    this.toggle(id, true, nextState.aside[id].closeable);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.checkIsMobile());
    }

    checkIsMobile() {
        this.setState({ mobile: window.innerWidth <= 768 });
    }

    toggle(id: string, open: boolean, closeable: boolean) {
        this.setState(prevState => {
            const aside = { ...prevState.aside };

            aside[id] = { open, closeable };

            let anotherIsOpen = false;

            for (const key in aside)
                if (aside[key].open && key !== id) {
                    anotherIsOpen = true;

                    break;
                }

            const closing = !open && !anotherIsOpen ? id : false;

            if (this.timeout !== undefined)
                window.clearTimeout(this.timeout);

            // Quando for fechar, atualiza com um delay de 0.5s, devido a animação de saída (está no SCSS)
            if (closing)
                this.timeout = window.setTimeout(() => this.setState({ closing: false }), 500);

            return { aside, closing };
        });
    }

    toggleAll(open?: boolean) {
        for (const id in this.state.aside)
            if (this.state.aside[id].closeable)
                this.toggle(id, open !== undefined ? open : !this.state.aside[id].open, this.state.aside[id].closeable);
    }

    isCloseable() {
        for (const id in this.state.aside)
            if (this.state.aside[id].closeable)
                return true;

        return false;
    }

    isOpen() {
        for (const id in this.state.aside)
            if (this.state.aside[id].open)
                return true;

        return false;
    }

    render() {
        const open = this.isOpen();

        const { mobile, ...state } = this.state;

        return (
            <AsideContext.Provider value={{ ref: this.ref, ...state, toggle: (...args) => this.toggle(...args) }}>
                <div className={`brax-asides ${open ? 'open' : ''}`}>
                    <div>{ this.props.children }</div>

                    <div>
                        <div ref={this.ref} />
                    </div>

                    { this.isCloseable() && mobile ? (
                        <BraxIcon icon={open ? 'close' : 'three-dots'} onClick={() => this.toggleAll()} />
                    ) : null }
                </div>
            </AsideContext.Provider>
        );
    }

}
